// src/components/Breadcrumb.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function Breadcrumb({ items }) {
  return (
    <div style={{
      background: '#9FBE6A',
      padding: '10px 0',
    }}>
      <div style={{ maxWidth:1280, margin:'0 auto', padding:'0 24px', display:'flex', alignItems:'center', gap:8, fontSize:13, fontWeight:600 }}>
        {items.map((item, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span style={{ color:'rgba(30,64,31,0.5)', fontSize:16 }}>›</span>}
            {item.href
              ? <Link to={item.href} style={{ color:'#1e401f', textDecoration:'none', fontWeight:700 }}>{item.label}</Link>
              : <span style={{ color:'#2c5e2e' }}>{item.label}</span>
            }
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
